import { AxiosError, AxiosResponse } from "axios";
import {
	ICRARamittance,
	ICRARamittanceListPayload,
	ICRARamittanceResponse,
} from "../models/CRARamittance";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const CRARamittanceService = {
	getCRARamittance: async (
		clientId: string,
		remittanceFrequencyId: string | undefined,
		managedBy: number,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| ICRARamittanceListPayload
		| IServerError
		| IResponse
		| ICRARamittanceResponse[]
		| null
	> => {
		if (!remittanceFrequencyId) return null;
		try {
			const response: AxiosResponse<ICRARamittanceListPayload> =
				await http.get<ICRARamittanceListPayload>(
					"/v1/cra-remittance/?client_id=" +
						clientId +
						"&remittance_frequency_id=" +
						remittanceFrequencyId +
						"&tax_year=" +
						taxYear +
						"&managed_by=" +
						managedBy,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getCRARamittanceSavedFrequency: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| ICRARamittanceListPayload
		| IServerError
		| IResponse
		| ICRARamittanceResponse[]
		| null
	> => {
		try {
			const response: AxiosResponse<ICRARamittanceListPayload> =
				await http.get<ICRARamittanceListPayload>(
					"/v1/cra-remittance/" + clientId + "/?tax_year=" + taxYear,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	create: async (
		requestPayload: any,
	): Promise<ICRARamittance | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ICRARamittance> =
				await http.put<ICRARamittance>("/v1/cra-remittance/", requestPayload);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delCRARemittance: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		const updatedDeleteDataPayload = {
			...delPayload.craRamittanceRowData,
			remitAmount: null,
			penaltyPercentage: null,
			penaltyCalculated: null,
			chequeNo: null,
			chequeDate: null,
			status: "Due",
		};
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<ICRARamittance> =
				await http.put<ICRARamittance>("/v1/cra-remittance/", {
					data: [updatedDeleteDataPayload],
				});

			if (response.status === 200) {
				return "Record has been deleted successfully.";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getRemittanceFrequencyDDL: async (): Promise<
		any | IServerError | IResponse | null | any
	> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/remittance-frequency/remittance-frequency-ddl`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	createCraRemittanceFrequency: async (
		clientId: string,
		remittanceFrequencyId: string | undefined,
		managedBy: number,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<ICRARamittance | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ICRARamittance> =
				await http.post<ICRARamittance>(
					`/v1/cra-remittance/?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`,
				);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	exportCraRemittanceExcelReport: async (
		clientId: string,
		remittanceFrequencyId: string,
		taxYear: number,
		managedBy: number,
	): Promise<any | IServerError | IResponse | any> => {
		
			const url = `/v1/all-remittance-printing/cra-remittance-xlsx?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		
	},
};
